import { createFileRoute } from "@tanstack/react-router";

import CliSdksPage from "./-components/CliSdksPage";

export const Route = createFileRoute("/_app/_dashboard/integrations/cli-sdks")({
  component: CliSdksPage,
});
